import graphql__5b0c307e97381af0d6c0 from "./__generated__/MapSidebarEventsList_eventsList.graphql.js";import { useCallback, useState } from "react";
import { graphql, useFragment } from "react-relay";
import { useDispatch, useSelector } from "react-redux";

import SidebarEventCard from "../Events/SidebarEventCard";
import MapElementImage from "./MapElementImage";
import Collapse from "../Utils/Collapse";
import CollapseSwitch from "../Utils/CollapseSwitch";
import CollapseContent from "../Utils/CollapseContent";
import { useMapContext } from "./MapContext";

import { setEventsListActive } from "../../reducers/map/filters";

const MapSidebarEventsList = props => {
  const eventsList = useFragment(MapSidebarEventsList_eventsList, props.eventsList);
  const { id: eventsListId, title, events, style } = eventsList;
  const { color, contrastColor } = style.iconStyle;

  const [isOpen, setIsOpen] = useState(false);

  const headerStyle = {};
  headerStyle.color = isOpen ? contrastColor : color;
  headerStyle.backgroundColor = isOpen ? color : contrastColor;

  const iconStyle = { ...style.iconStyle };

  if (isOpen) {
    iconStyle.color = contrastColor;
    iconStyle.contrastColor = color;
  }

  const iconHTML = MapElementImage({
    ...iconStyle,
    width: 25,
    height: 25,
    position: "static"
  });

  const dispatch = useDispatch();
  const { mapKey } = useMapContext();
  const activeEventsListId = useSelector(
    ({ map }) => map[mapKey].filters.activeEventsListId
  );

  const handleCollapseExpandedChanged = useCallback(
    isExpanded => {
      setIsOpen(isExpanded);

      if (isExpanded) {
        dispatch(setEventsListActive(mapKey, eventsListId));
      } else if (activeEventsListId === eventsListId) {
        dispatch(setEventsListActive(mapKey, null));
      }
    },
    [activeEventsListId, dispatch, eventsListId, mapKey]
  );

  const shouldCollapse = useCallback(() => {
    return isOpen && activeEventsListId && activeEventsListId !== eventsListId;
  }, [activeEventsListId, eventsListId, isOpen]);

  return (
    <Collapse
      onExpandedChanged={handleCollapseExpandedChanged}
      shouldCollapse={shouldCollapse}
    >
      <CollapseSwitch
        className="map-sidebar-element padding-sm btn btn-block btn-unstyled text-left d-flex align-items-center margin-bottom-xxs box box-shadow"
        style={headerStyle}
      >
        <span
          className="d-block padding-right-xs"
          dangerouslySetInnerHTML={{ __html: iconHTML }}
        />

        {title}
      </CollapseSwitch>

      <CollapseContent className="boxes-list">
        <ul className="padding-none">
          {events.map(event => (
            <SidebarEventCard
              key={event.id}
              participativeModule={event}
              itemId={event.id}
              itemType="event"
            />
          ))}
        </ul>
      </CollapseContent>
    </Collapse>
  );
};

const MapSidebarEventsList_eventsList = graphql__5b0c307e97381af0d6c0;

export default MapSidebarEventsList;
